import ImageActionSheet from './ImageActionSheet'
import nudgeImage from '../../../public/assets/bottomNudgeImage.webp'

const ExitBottomSheet = ({
  isOpen,
  onClose,
  onContinue = () => {},
  onLeave = () => {},
  candidateCount = '75000'
}) => (
  <ImageActionSheet
    isOpen={isOpen}
    isHeaderPresent={false}
    showCloseIcon={true}
    onClose={onClose}
    headerImage={nudgeImage}
    title={
      <span>
        <span className="font-bold">{`${candidateCount}+ candidates`}</span> are actively looking
        for job
      </span>
    }
    description="You are just 1 step away from getting the best candidates."
    primary={{ label: 'Continue Hiring', onClick: onContinue }}
    secondary={{ label: 'Leave page', onClick: onLeave }}
  />
)

export default ExitBottomSheet
